import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	buttonContainer: {
		display: 'flex',
		gap: SPACE[8],
		alignItems: 'center',
	},
});
